<template>
  <div class="user">
    <!-- 搜索区域 -->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="城建招标名称">
          <el-input placeholder="请输入城建招标名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item label="招标类型">
          <el-select v-model="formInline.status" placeholder="请选择">
            
            <el-option label="政府招标" value="1"></el-option>
            <el-option label="企业招标" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作按钮 -->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加城建招标</el-button>
    </div>

    <!-- 表格区域 -->
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="城建招标名称"></el-table-column>
            <el-table-column prop="code" label="招标编号"></el-table-column>
            <el-table-column prop="status" label="招标类型">
              <template slot-scope="scope">
                {{ scope.row.status === '0' ? '政府招标' : '企业招标' }}
              </template>
            </el-table-column>
             <el-table-column prop="products" label="关联项目"></el-table-column>
            <el-table-column prop="budget" label="预算金额(万元)"></el-table-column>
            <el-table-column prop="endTime" label="截至时间"></el-table-column>
            <el-table-column prop="company" label="招标单位"></el-table-column>
                 <el-table-column prop="region" label="地区"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <!-- 添加和编辑弹窗 -->
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :Urban_id="Urban_id" v-if="open_edit" @close="closeEdit"></Edit>
  </div>
</template>

<script>
import UrbanApi from '@/api/urban.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Add,
    Edit,
  },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      form: {},
      formInline: {
        search: "",
        status: ""
      },
      open_add: false,
      open_edit: false,
      Urban_id: ""
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      UrbanApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    addClick() {
      this.open_add = true;
    },
    editClick(row) {
      console.log('row',row);
      
      this.Urban_id = row.Urban_id;
      console.log('Urban_id',this.Urban_id);
      
      this.open_edit = true;
    },
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        UrbanApi.del({ Urban_id: row.Urban_id }, true)
          .then(data => {
            if (data.code == 1) {
              self.$message({ message: '删除成功', type: 'success' });
              this.getTableList();
            } else {
              self.$message.error(data.msg || '删除失败');
            }
          })
          .catch(error => {
            self.$message.error('删除失败');
          });
      }).catch(() => {});
    }
  }
};
</script>

<style>
/* 可以添加一些自定义样式 */
</style>


// WEBPACK FOOTER //
// src/views/plus/urban/index/index.vue